import {Directive, ElementRef, Input, Component} from '@angular/core';

@Directive({
  selector: '[canbedisabled]'
})
export class Canbedisabled {

  constructor(private el: ElementRef) {

  }

  @Input()
  set blocked(blocked: boolean) {
    this.el.nativeElement.disabled = blocked;
  }
}





// WEBPACK FOOTER //
// ./src/app/shared/canbedisabled.directive.ts